// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderList_wrapper__jbFfh","title":"OrderList_title__PH3eR","item":"OrderList_item__szGwM"};